import { render, staticRenderFns } from "./KPIForm.vue?vue&type=template&id=fbae17fa&scoped=true&"
import script from "./KPIForm.vue?vue&type=script&lang=js&"
export * from "./KPIForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbae17fa",
  null
  
)

export default component.exports